import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { appLayoutRoute } from '@/app/routes/roots';
import { validateTransferWindowsSearch } from './lib/windowsSearch';

/**
 * The status filter is URL state, as every filter in this app is. The selected
 * league is not: it is a reading position rather than a filter, it defaults to
 * the Premier League on every visit, and putting it in the URL would put a
 * history entry behind each row the user glances at.
 */
export const transferWindowsRoute = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: '/transfer-windows',
  component: lazyRouteComponent(() => import('./pages/TransferWindowsPage'), 'TransferWindowsPage'),
  validateSearch: validateTransferWindowsSearch,
});

export const transferWindowsRoutes = [transferWindowsRoute];
